module.exports = __webpack_public_path__ + "static/media/food-chain-thumbnail-article.ecf944ab.jpg";